import { getMetaConfig } from '../utils'
import Task from 'data.task'

export const isMsAuthEnabled = getMetaConfig('microsoftAuthEnabled') === 'true'
export const msClientId = getMetaConfig(
  'msClientId',
  'fccffc6b-952f-4df9-a084-383c2ea206aa'
)
export const ocidRedirectUri = getMetaConfig('ocidRedirectUri')
export const msAuthAuthority = getMetaConfig(
  'msAuthAuthority',
  'https://login.microsoftonline.com/69650c40-6a40-4e5e-900b-6ce64d93fd2d'
)

export const noopTask = Task.of(null)
export const noopTaskCallback = () => Task.of(null)
